module.exports = __webpack_public_path__ + "static/media/download-pdf.da7290fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/images/download-pdf.png
// module id = 192
// module chunks = 0